import { create } from 'zustand';
import {
  ToastActionsType,
  ToastStateType,
} from '@/common/store/alert/useToast.type.ts';

const useToast = create<ToastStateType & ToastActionsType>((set) => ({
  show: false,
  type: 'success',
  duration: 2000,
  description: '',
  showAlert: ({ duration = 4000, ...alert }) =>
    set((state) => {
      setTimeout(() => {
        state.closeAlert();
      }, duration);
      return { duration, show: true, ...alert };
    }),
  closeAlert: () => set(() => ({ show: false })),
}));
export default useToast;
